import React from 'react';

import { FlexDiv, GenericDiv, GenericP, TooltipContainer } from 'commonStyles';
import { ApprovalIcons, FlightLegSide } from './listingStyles';

import ToolTip from 'common/Tooltip/PortaledTooltip';

import { getStopsLabel } from 'UtilityComponents/Util';

const STOP_COLORS = {
	NON_STOP: '#33D18F',
	HAS_STOPS: '#EB2026'
};

const getStopsColor = (stops) => {
	const count = Number(stops);
	return Number.isFinite(count) && count > 0 ? STOP_COLORS.HAS_STOPS : STOP_COLORS.NON_STOP;
};

const joinAirportAndTerminal = (airportName, terminal) => (
	[airportName, terminal].filter(Boolean).join(', ')
);

const renderEnd = ({ time, code, city, airportName, terminal, align }) => {
	const textAlign = align === 'end' ? 'right' : 'left';
	const flexAlign = align === 'end' ? 'flex-end' : 'flex-start';
	const airportLine = joinAirportAndTerminal(airportName, terminal);

	return (
		<FlightLegSide $direction='column' align={flexAlign} $gap='2px' $width='auto'>
			{time && (
				<GenericP fsize='16px' f_weight='900' $lHeight='24px' color='#000' text_align={textAlign}>
					{time}
				</GenericP>
			)}
			{(city || code) && (
				<GenericP fsize='14px' f_weight='900' $lHeight='20px' color='#000' text_align={textAlign}>
					{city || code}
				</GenericP>
			)}
			{airportLine && (
				<GenericP fsize='12px' $lHeight='16px' color='#4a4a4a' text_align={textAlign}>
					{airportLine}
				</GenericP>
			)}
		</FlightLegSide>
	);
};

const renderLeg = (leg, index) => {
	const {
		source, destination,
		sourceCity, destinationCity,
		sourceAirportName, destinationAirportName,
		sourceTerminal, destinationTerminal,
		departureTime, arrivalTime,
		duration, stops
	} = leg || {};
	const routeHeader = source && destination ? `${source} - ${destination}` : (source || destination || '');
	const stopsLabel = getStopsLabel(stops);
	const stopsColor = getStopsColor(stops);

	return (
		<FlexDiv key={`${source}-${destination}-${index}`} $direction='column' $gap='8px'>
			{routeHeader && (
				<GenericP fsize='12px' f_weight='900' $lHeight='16px' color='#000'>{routeHeader}</GenericP>
			)}
			<FlexDiv align='flex-start' justify='space-between' $gap='12px'>
				{renderEnd({
					time: departureTime,
					code: source,
					city: sourceCity,
					airportName: sourceAirportName,
					terminal: sourceTerminal,
					align: 'start'
				})}
				<FlexDiv $direction='column' align='center' $gap='4px' $width='64px' padding='4px 0 0 0'>
					{duration && (
						<GenericP fsize='12px' $lHeight='16px' color='#4a4a4a'>{duration}</GenericP>
					)}
					<GenericDiv $width='56px' height='2px' $bg={stopsColor} />
					<GenericP fsize='12px' $lHeight='16px' color='#4A4A4A' f_weight='700'>
						{stopsLabel}
					</GenericP>
				</FlexDiv>
				{renderEnd({
					time: arrivalTime,
					code: destination,
					city: destinationCity,
					airportName: destinationAirportName,
					terminal: destinationTerminal,
					align: 'end'
				})}
			</FlexDiv>
		</FlexDiv>
	);
};

const FlightInfoTooltip = ({ legs = [] }) => {
	if (!Array.isArray(legs) || legs.length === 0) return null;

	return (
		<TooltipContainer position='relative' valign='middle'>
			<ApprovalIcons icon='flightInfo' />
			<ToolTip
				top_arr
				bg_color='#fff'
				color='#000'
				bdr='1px solid #d8d8d8'
				boxShadow='0 1px 3.5px rgba(0, 0, 0, 0.2)'
				padding='12px'
				$width='320px'>
				<FlexDiv $direction='column' $gap='12px'>
					{legs.map((leg, index) => (
						<React.Fragment key={`${leg?.source}-${leg?.destination}-${index}`}>
							{index > 0 && <GenericDiv $width='100%' height='1px' $bg='#d8d8d8' />}
							{renderLeg(leg, index)}
						</React.Fragment>
					))}
				</FlexDiv>
			</ToolTip>
		</TooltipContainer>
	);
};

export default React.memo(FlightInfoTooltip);
